module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full relative flex flex-col space-y-2.5 pt-0.5 pb-2.5 rounded"
  }, [_c('div', {
    staticClass: "w-full px-2 mt-0.5 font-manrope",
    class: {
      'mt-9': _vm.isFullscreen
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchStudents),
      expression: "searchStudents"
    }],
    staticClass: "bg-white border border-solid border-gray-200 rounded-lg py-2 px-3 w-full focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
    attrs: {
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.searchStudents)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchStudents = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.searchStudents !== '') ? _c('div', {
    staticClass: "flex flex-col space-y-2 flex-grow h-full w-full"
  }, [(_vm.studentsFiltered.length !== 0) ? _c('ul', _vm._l((_vm.studentsFiltered), function(student, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "py-2 flex justify-between items-center hover:bg-gray-100 rounded-lg px-3.5 text-gray-900 cursor-pointer",
      class: {
        'opacity-50': !_vm.isStudentOnline(student.user_id)
      }
    }, [_c('div', {
      staticClass: "flex items-center space-x-2.5",
      on: {
        "click": function($event) {
          return _vm.openParticipantFromTapIn(student.user_id)
        }
      }
    }, [_c('div', {
      staticClass: "relative"
    }, [_c('img', {
      staticClass: "w-6 rounded-full object-cover h-6",
      attrs: {
        "src": student.user.avatar_url
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-ellipsis truncate"
    }, [_vm._v("\n              " + _vm._s(student.user.name) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('div', [(student.turn_count !== '0') ? _c('div', {
      staticClass: "space-x-1 flex items-center"
    }, [_c('i', {
      staticClass: "fa-solid fa-bullhorn text-gray-700 text-xs"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.studentInCircleTurnCount(student.id)))])]) : _vm._e()]), _vm._v(" "), _c('pl-menu', {
      attrs: {
        "direction": "right",
        "menuSize": 3
      }
    }, [_c('button', {
      staticClass: "rounded-full h-6 w-6 flex justify-center items-center hover:bg-gray-200",
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fa-solid fa-ellipsis text-gray-600 hover:text-gray-800"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('Actions', {
      attrs: {
        "selectedUserType": "TapIn",
        "selectedStudent": student
      },
      on: {
        "setAsModerator": function($event) {
          return _vm.$emit('setAsModerator', student)
        },
        "handleNudge": function($event) {
          return _vm.$emit('openSendNudge', true, student)
        }
      }
    })], 1)])], 1)])])
  }), 0) : _vm._e()]) : _c('div', {
    staticClass: "flex flex-col space-y-2 flex-grow h-full w-full px-1"
  }, [_c('div', {
    staticClass: "w-full flex mt-0.5 flex-col space-y-2",
    attrs: {
      "id": "speaker-spot"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center text-gray-800 font-semibold px-2"
  }, [_c('h6', {
    staticClass: "cursor-default font-manrope font-semibold"
  }, [_vm._v("Speaker")]), _vm._v(" "), (_vm.getCurrentDiscussion.currently_active) ? _c('button', {
    staticClass: "sample hover:underline text-xs subpixel-antialiased text-gray-500",
    on: {
      "click": function($event) {
        return _vm.removeSpeaker(_vm.currentSpeaker.user.id)
      }
    }
  }, [_vm._v("\n          Clear\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.getCurrentDiscussion.currently_active) ? _c('div', {
    staticClass: "py-2.5 flex justify-between items-center rounded-lg bg-lightBlue-100 cursor-pointer px-3.5 text-gray-900"
  }, [_c('div', {
    staticClass: "flex items-center cursor-pointer space-x-3",
    on: {
      "click": function($event) {
        return _vm.handleOpenParticipantAssessment(_vm.currentSpeaker)
      }
    }
  }, [_c('div', {
    staticClass: "w-6 relative h-6 rounded-full ring-2 ring-lightBlue-500 ring-offset-2"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": _vm.currentSpeaker.user.avatar_url
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "w-full text-ellipsis truncate font-manrope"
  }, [_vm._v("\n                " + _vm._s(_vm.currentSpeaker.user.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-2 items-center sample"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [(_vm.isUserModerator(_vm.currentSpeaker.id)) ? _c('div', {
    staticClass: "space-x-1 flex items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-gavel text-xs text-gray-700"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentSpeaker.turn_count !== '0') ? _c('div', {
    staticClass: "space-x-1 flex items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-bullhorn text-gray-700 text-xs"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentSpeaker.turn_count))])]) : _vm._e()]), _vm._v(" "), _c('pl-menu', {
    attrs: {
      "direction": "right",
      "menuSize": 3
    }
  }, [_c('button', {
    staticClass: "rounded-full h-6 w-6 flex justify-center items-center hover:bg-gray-200",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('i', {
    staticClass: "fa-solid fa-ellipsis text-gray-600 hover:text-gray-800"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, [_c('Actions', {
    attrs: {
      "selectedUserType": "Speaker",
      "selectedStudent": _vm.currentSpeaker
    },
    on: {
      "setAsModerator": function($event) {
        return _vm.$emit('setAsModerator', _vm.currentSpeaker)
      },
      "handleNudge": function($event) {
        return _vm.$emit('openSendNudge', true, _vm.currentSpeaker)
      }
    }
  })], 1)])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.getCurrentDiscussion.currently_active) ? _c('div', {
    staticClass: "py-0.5 px-3.5 cursor-default"
  }, [_c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v("No Speaker")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2 w-full",
    attrs: {
      "id": "tapped-in-spot"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center text-gray-800 font-semibold px-2"
  }, [_c('h6', {
    staticClass: "cursor-default font-semibold font-manrope"
  }, [_vm._v("\n          Tapped In\n          "), (_vm.getCurrentDiscussion.currently_active) ? _c('span', [_vm._v("\n            (" + _vm._s(_vm.usersInCircle.length - 1) + ")\n          ")]) : _c('span', [_vm._v(" (" + _vm._s(_vm.usersInCircle.length) + ") ")])]), _vm._v(" "), (_vm.studentsTappedIn > 0) ? _c('button', {
    staticClass: "sample hover:underline py-1 text-xs subpixel-antialiased text-gray-500",
    on: {
      "click": _vm.removeAllTapIn
    }
  }, [_vm._v("\n          Clear All\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.usersInCircle.length > 0) ? _c('div', [_c('div', _vm._l((_vm.usersInCircle), function(studentInCircle, index) {
    return _c('ul', {
      key: index
    }, [(studentInCircle.participation.user.id !== _vm.getCurrentDiscussion.currently_active) ? _c('li', [_c('div', {
      staticClass: "py-2 flex justify-between items-center hover:bg-gray-100 rounded-lg px-3.5 text-gray-900 cursor-pointer"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2.5",
      on: {
        "click": function($event) {
          return _vm.openParticipantFromTapIn(studentInCircle.participation.user.id)
        }
      }
    }, [_c('div', {
      staticClass: "relative"
    }, [_c('img', {
      staticClass: "w-6 rounded-full object-cover h-6",
      attrs: {
        "src": studentInCircle.participation.user.avatar_url
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-ellipsis truncate font-manrope"
    }, [_vm._v("\n                    " + _vm._s(studentInCircle.participation.user.name) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('div', {
      staticClass: "flex space-x-2 items-center"
    }, [(_vm.isUserModerator(studentInCircle.participation_id)) ? _c('div', {
      staticClass: "space-x-1 flex items-center"
    }, [_c('i', {
      staticClass: "fa-solid fa-gavel text-xs text-gray-700"
    })]) : _vm._e(), _vm._v(" "), (studentInCircle.turn_count !== '0') ? _c('div', {
      staticClass: "space-x-1 flex items-center"
    }, [_c('i', {
      staticClass: "fa-solid fa-bullhorn text-gray-700 text-xs"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.studentInCircleTurnCount(studentInCircle.participation.id)))])]) : _vm._e()]), _vm._v(" "), _c('pl-menu', {
      attrs: {
        "direction": "right",
        "menuSize": 3
      }
    }, [_c('button', {
      staticClass: "rounded-full h-6 w-6 flex justify-center items-center hover:bg-gray-200",
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fa-solid fa-ellipsis text-gray-600 hover:text-gray-800"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('Actions', {
      attrs: {
        "selectedUserType": "TapIn",
        "selectedStudent": studentInCircle,
        "selectedTapInUser": studentInCircle
      },
      on: {
        "setAsModerator": function($event) {
          return _vm.$emit('setAsModerator', studentInCircle.participation)
        },
        "handleNudge": function($event) {
          return _vm.$emit('openSendNudge', true, studentInCircle.participation)
        }
      }
    })], 1)])], 1)])]) : _vm._e()])
  }), 0)]) : _c('div', {
    staticClass: "py-0.5 px-3.5 cursor-default"
  }, [_c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v("No tapped in students")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "online-spot"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center text-gray-800 font-semibold px-2 mb-1"
  }, [_c('h6', {
    staticClass: "cursor-default font-semibold font-manrope"
  }, [_vm._v("Online (" + _vm._s(_vm.studentsOnline) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "p-1",
    on: {
      "click": function($event) {
        _vm.isOnlineMenuOpen = !_vm.isOnlineMenuOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid text-base text-gray-600",
    class: _vm.isOnlineMenuOpen ? 'fa-angle-down' : 'fa-angle-up'
  })])]), _vm._v(" "), (_vm.studentsOnline > 0) ? _c('div', [(_vm.isOnlineMenuOpen === true) ? _c('ul', _vm._l((_vm.studentsFiltered), function(student, index) {
    return _c('li', {
      key: index
    }, [(_vm.isStudentOnline(student.user_id) && _vm.isStudentNotInCircle(student.user_id) && student.user_id !== _vm.getCurrentDiscussion.currently_active) ? _c('div', {
      staticClass: "py-2 flex justify-between items-center hover:bg-gray-100 rounded-lg cursor-pointer px-4 text-gray-900",
      on: {
        "click": function($event) {
          return _vm.handleOpenParticipantAssessment(student)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center space-x-2.5 relative"
    }, [_c('div', {
      staticClass: "relative"
    }, [_c('img', {
      staticClass: "w-6 rounded-full object-cover h-6",
      attrs: {
        "src": student.user.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "absolute bottom-0 right-0 h-2 w-2 bg-green-500 rounded-full"
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-ellipsis truncate"
    }, [_vm._v("\n                  " + _vm._s(student.user.name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [(_vm.isUserModerator(student.id)) ? _c('div', [_c('i', {
      staticClass: "fa-solid fa-gavel text-xs text-gray-700"
    })]) : _vm._e(), _vm._v(" "), _c('pl-menu', {
      attrs: {
        "direction": "right",
        "menuSize": 3
      }
    }, [_c('button', {
      staticClass: "rounded-full h-6 w-6 flex justify-center items-center hover:bg-gray-200",
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fa-solid fa-ellipsis text-gray-600 hover:text-gray-800"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('Actions', {
      attrs: {
        "selectedUserType": "Online",
        "selectedStudent": student
      },
      on: {
        "setAsModerator": function($event) {
          return _vm.$emit('setAsModerator', student)
        },
        "handleNudge": function($event) {
          return _vm.$emit('openSendNudge', true, student)
        }
      }
    })], 1)])], 1)]) : _vm._e()])
  }), 0) : _vm._e()]) : _c('div', {
    staticClass: "py-0.5 px-3.5 cursor-default"
  }, [_c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v("No students online")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "offline-spot"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center text-gray-900 font-semibold px-2 font-manrope mb-1"
  }, [_c('h6', {
    staticClass: "font-semibold text-gray-400"
  }, [_vm._v("\n          Offline (" + _vm._s(_vm.studentsOffline) + ")\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "p-1",
    on: {
      "click": function($event) {
        _vm.isOfflineMenuOpen = !_vm.isOfflineMenuOpen
      }
    }
  }, [(_vm.studentsOffline > 0) ? _c('i', {
    staticClass: "fa-solid text-base text-gray-700",
    class: _vm.isOfflineMenuOpen ? 'fa-angle-down' : 'fa-angle-up'
  }) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.isOfflineMenuOpen === true) ? _c('ul', _vm._l((_vm.studentsFiltered), function(studentParticipant, index) {
    return (!_vm.isStudentOnline(studentParticipant.user.id) && _vm.isStudentNotInCircle(studentParticipant.user.id)) ? _c('li', {
      key: index,
      staticClass: "py-2.5 flex justify-between items-center rounded-lg cursor-default hover:bg-gray-100 px-3.5 text-gray-400",
      on: {
        "click": function($event) {
          return _vm.handleOpenParticipantAssessment(studentParticipant)
        },
        "mouseover": function($event) {
          _vm.activeTapInOption = index
        },
        "mouseout": function($event) {
          _vm.activeTapInOption = null
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center space-x-2.5"
    }, [_c('span', [_vm._v(_vm._s(studentParticipant.user.name))])]), _vm._v(" "), (_vm.discussionIsLive && !_vm.audioVideoIsActive && !_vm.isStudentInCircle.includes(studentParticipant.id)) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTapInOption === index),
        expression: "activeTapInOption === index"
      }],
      staticClass: "sample hover:text-yellow-500 px-2",
      attrs: {
        "disabled": _vm.tapin
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.tapInByTeacher(studentParticipant.user.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-arrow-up-from-bracket rotate-90"
    })]) : _vm._e()]) : _vm._e()
  }), 0) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4564fd4e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/Participants/ListParticipants.vue
// module id = 1808
// module chunks = 61